const numeral = require('numeral'); // Jest tests were breaking with the typical import

function formatCurrency(num: number): string {
  return numeral(num).format('$0,0.00');
}

function wholeNumber(num: number): string {
  return numeral(num).format('$0,0');
}

function wholeNumberPercentage(num: number): string {
  return `${numeral(num).format('0')}%`;
}

function stringToWholeNumber(str: string): string {
  const num = parseFloat(str);
  return numeral(num).format('$0,0');
}

function formatCurrencyChange(num: number): string {
  // numeral has a bug where '1234' will render '-1$,234.00' with this string
  const positive = '+$0,0.00';
  const negative = '$0,0.00';

  return numeral(num).format(num <= 0 ? negative : positive);
}

function formatNumber(num: number | string, decimalPlaces: number = 2): string {
  return numeral(num).format(`0,0.${'0'.repeat(decimalPlaces)}`);
}

function formatPercentage(num: number, decimalPlaces: number = 2): string {
  return numeral(num / 100).format(`0,0.${'0'.repeat(decimalPlaces)}%`);
}

function formatPercentageChange(
  num: number,
  decimalPlaces: number = 2
): string {
  const positive = `+0,0.${'0'.repeat(decimalPlaces)}%`;
  const negative = `0,0.${'0'.repeat(decimalPlaces)}%`;

  return numeral(num / 100).format(num <= 0 ? negative : positive);
}

export {
  formatCurrency,
  formatCurrencyChange,
  formatPercentage,
  formatPercentageChange,
  formatNumber,
  stringToWholeNumber,
  wholeNumber,
  wholeNumberPercentage
};
